import {isoFormatToLocalTimeString} from '../../../helpers/dateTimeHelper';
import DropdownMenu, {
  DropdownItem, DropdownItemGroup
} from '@atlaskit/dropdown-menu';
import CustomIcon, {CustomIconRef} from 'components/CustomIcon';
import {tabItems} from './CampaignsJobs';
import {capitalizeFirstLetter} from '../../../helpers/stringHelper';
import {confirmSalesOrder, generateSalesOrder, updateSalesOrder} from "../../../redux/slices/nurseCampaignSlice";
import {useDispatch} from "react-redux";
import {useParams} from 'react-router-dom';
import React from "react";
import CustomButton from "../../../components/CustomButton";
import FormLabel from "../../../components/form/FormLabel";
import {Tag} from "../../../components/table/Status";

const AppointmentCard = ({
                           appointment,
                           setModalData,
                           activeTab,
                           setSelectAppointmentsIds,
                           setSelectAppointment,
                           selectedIds,
                           setActiveModalComponent,
                           modalOption,
                           index,
                           ...props
                         }) => {
  const title = `${appointment?.requested_by?.first_name} ${appointment?.requested_by?.last_name}(${appointment?.requested_by?.mobile}) has requested for ${appointment?.campaign?.title} for ${appointment?.requested_for?.first_name} (${appointment?.requested_for?.mobile}) `;
  const dispatch = useDispatch();
  const {campaign_id} = useParams();


  return (

    <div className="custom-card flex items-start space-x-4">
      {activeTab !== tabItems[2] && (<input
        className="w-5 h-5"
        type="checkbox"
        checked={selectedIds?.includes(appointment?.id)}
        onChange={(e) => {
          setSelectAppointmentsIds(appointment?.id, e.target.checked);
        }}
      />)}
      <div className="flex-1">
        <div className="flex justify-between items-start">
          <div
            className="text-xl leading-4 mb-2">{capitalizeFirstLetter(appointment?.requested_by?.first_name) + " " + capitalizeFirstLetter(appointment?.requested_by?.last_name)}</div>


          {
            activeTab !== tabItems[2] &&
            <DropdownMenu
              trigger={({triggerRef, isSelected, testId, ...props}) => (<CustomIconRef
                ref={triggerRef}
                size="2xl"
                className="cursor-pointer"
                {...props}
                icon="more_vert"
              />)}
            >
              <DropdownItemGroup>
                <DropdownItem onClick={() => {
                  setSelectAppointment(appointment);
                  setActiveModalComponent(modalOption.cancelBooking);
                  setModalData({});
                }}>Cancel Booking</DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setSelectAppointment(appointment);
                    setActiveModalComponent(modalOption.updateOrder);
                    setModalData({});
                  }}
                >
                  Update Quantity
                </DropdownItem>
              </DropdownItemGroup>
            </DropdownMenu>
          }
        </div>
        <div className="">
          <div className="flex flex-wrap space-x-4 text-sm mb-3">
            <div className="flex items-start space-x-1"><CustomIcon icon="phone_iphone"/>
              <span>{appointment?.requested_by?.mobile}</span></div>
            <div className="flex items-start space-x-1"><CustomIcon icon="location_on"/>
              <span>{`${appointment?.address?.landmark}, ${appointment?.address?.area?.name}, ${appointment?.address?.city?.name}, ${appointment?.address?.province?.name}`}</span></div>
          </div>
          <FormLabel label="Appointment Info"/>
          <div className="rounded-md bg-white p-4 flex mb-4">
            <Info label="Date" value={appointment?.appointment_date}/>
            <Info label="Time" classname="w-1/3"
                  value={isoFormatToLocalTimeString(appointment?.start_time, true) + " - " + isoFormatToLocalTimeString(appointment?.end_time, true)}/>
            <Info label="Quantity" value={appointment?.quantity}/>
            {activeTab !== tabItems[0] && <Info label="Quantity Redeemed" value={appointment?.redeemed}/>}
            <Info label="Price" value={appointment?.price}/>
            <Info label="Total Savings" value={appointment?.savings}/>
          </div>
          {activeTab !== tabItems[0] && (
            <>
              <FormLabel label="Sales Order"/>
              <div className="rounded-md bg-white p-4 flex mb-4">
                <Info label="Status" value={appointment?.sales_order?.status}/>
                <Info label="Quantity" value={appointment?.quantity}/>
                <Info label="Remarks" classname="w-full" value={appointment?.sales_order?.remarks}/>
              </div>
            </>
          )}

          <div className="flex justify-between">
            <div>
              {activeTab === tabItems[1] && (<>
                <span className="text-sm">Assigned Nurse: </span>
                {appointment?.nurses?.map((nurse) => (
                  <Tag key={nurse?.id}
                       label={capitalizeFirstLetter(nurse?.first_name) + " " + capitalizeFirstLetter(nurse?.last_name)}/>))}
              </>)}
            </div>
            <div className="flex justify-end space-x-4">
              {activeTab === tabItems[1] && (
                <CustomButton
                  disabled={appointment?.hasOwnProperty('sales_order') && appointment?.sales_order?.status !== SALES_ORDER_CONSTANTS.FAILED}
                  onClick={() => {
                    dispatch(generateSalesOrder(appointment?.id));
                  }}
                >
                  Generate Sales Order
                </CustomButton>
              )}


              {activeTab === tabItems[2] && appointment?.sales_order && (
                <>
                  <CustomButton
                    disabled={
                      [SALES_ORDER_CONSTANTS.UPDATED, SALES_ORDER_CONSTANTS.CONFIRMED].includes(appointment?.sales_order?.status) || appointment?.sales_order?.quantity === appointment?.redeemed
                    }
                    onClick={() => {
                      dispatch(updateSalesOrder({
                        index,
                        campaignAppointmentId: appointment?.id
                      }));
                    }}>Update Sales Order</CustomButton>
                  <CustomButton
                    disabled={appointment?.sales_order?.status === SALES_ORDER_CONSTANTS.CONFIRMED || appointment?.redeemed !== appointment?.sales_order?.quantity}
                    onClick={() => {
                      dispatch(confirmSalesOrder({
                        index,
                        campaignAppointmentId: appointment?.id
                      }));
                    }}>Confirm Sales Order</CustomButton>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};


export const SALES_ORDER_CONSTANTS = {
  IN_DRAFT: "IN_DRAFT", FAILED: "FAILED", UPDATED: "UPDATED", CONFIRMED: "CONFIRMED"
};
export const Info = ({label, value, classname}) => {
  return <div className={classname ? classname : "w-1/4"}>
    <div className="text-rand-200 font-light text-xs">{label}</div>
    <div className="font-medium">{value}</div>
  </div>;
};

export default AppointmentCard;
